import React, {Fragment} from 'react';
import {Text, View, StyleSheet } from '@react-pdf/renderer';

const borderColor = '#000000'
const styles = StyleSheet.create({
    row: {
        flexDirection: 'row',
        borderBottomColor: '#000000',
        borderBottomWidth: 1,
        alignItems: 'center',
        height: 24,
        fontStyle: 'bold',
    },
    description: {
        width: '80%',
        textAlign: 'left',
        borderRightColor: borderColor,
        borderRightWidth: 1,
        paddingLeft: 8,
    },
    qtd: {
        width: '10%',
        borderRightColor: borderColor,
        borderRightWidth: 1,
        textAlign: 'center',
        paddingRight: 8,
    },
});

const OrderServiceTasksTableRow = ({items}) => {
    return (
        <Fragment>
            {items.map( item => {
                const quant = (item?.qtd) ? item.qtd : 0;
                return (
                <View style={styles.row} key={(item?.item?._id) ? item?.item?._id : 0}>
                    <Text style={styles.description}>{(item?.task?.name && item?.item?.name) ? `${item?.task?.name} - ${item?.item?.name}` : ''}</Text>
                    <Text style={styles.qtd}>{quant}</Text>
                    <Text style={styles.qtd}></Text>
                </View>
                )
            })}
        </Fragment> )
};
  
export default OrderServiceTasksTableRow